export default __webpack_public_path__ + "8dbc52d181a5ba3e48f1722d185fe978.png";